export class ZeroEtlJob {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "JobStatus",
            "format": ""
        },
        {
            "name": "jobType",
            "baseName": "jobType",
            "type": "ZeroEtlJobType",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceDetails",
            "baseName": "resourceDetails",
            "type": "ResourceDetails",
            "format": ""
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "policyId",
            "baseName": "policyId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "backupJobId",
            "baseName": "backupJobId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "baseSnapshotId",
            "baseName": "baseSnapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedTime",
            "baseName": "updatedTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "durationSeconds",
            "baseName": "durationSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "targetNamespaceTemplate",
            "baseName": "targetNamespaceTemplate",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetTableTemplate",
            "baseName": "targetTableTemplate",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableCounts",
            "baseName": "tableCounts",
            "type": "ZeroEtlJobTableCounts",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlJob.attributeTypeMap;
    }
    constructor() {
    }
}
